// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1YoH9","detailsBorder":"styles_detailsBorder__3gAsb"};